// src/config/config.js
const config = {
  API_BASE_URL: 'https://hd-sound-pro-backend.onrender.com' // Ensure this is correct
};

export default config;
